import React, { useState, useEffect } from 'react';
import { useSelector, shallowEqual } from 'react-redux';
import { Link } from 'react-router-dom';
import { Dropdown, DropdownItem, DropdownMenu, DropdownToggle } from 'reactstrap';

import logoSm from "../../assets/images/logo-sm.png";

const ProfileDropdown = () => {

    const { user } = useSelector(state => ({
        user: state.Profile.user,
    }), shallowEqual);

    const handleSignout = () => {
        localStorage.removeItem("authUser");
      };

    const [userName, setUserName] = useState("Admin");
    const [company, setCompany] = useState("");
    const [userImg, setUserImg] = useState(logoSm);

    useEffect(() => {
        if (localStorage.getItem("authUser")) {
            const obj = JSON.parse(localStorage.getItem("authUser"));
            setUserName(obj.name);
            setCompany(obj.company);
            if (obj.image) {
                setUserImg(obj.image);
            }
        }
    }, [userName, user]);

    //Dropdown Toggle
    const [isProfileDropdown, setIsProfileDropdown] = useState(false);
    const toggleProfileDropdown = () => {
        setIsProfileDropdown(!isProfileDropdown);
    };
    return (
        <React.Fragment>
            <Dropdown isOpen={isProfileDropdown} toggle={toggleProfileDropdown} className="ms-sm-3 header-item topbar-user">
                <DropdownToggle tag="button" type="button" className="btn shadow-none">
                    <span className="d-flex align-items-center">
                        <img className="rounded-circle header-profile-user" src={userImg}
                            alt="Header Avatar" onError={(e) => { e.target.onerror = null; e.target.src = logoSm; }} />
                        <span className="text-start ms-xl-2">
                            <span className="d-none d-xl-inline-block ms-1 fw-medium user-name-text">{userName}</span>
                            <span className="d-none d-xl-block ms-1 fs-12 text-muted user-name-sub-text">{company}</span>
                        </span>
                    </span>
                </DropdownToggle>
                <DropdownMenu className="dropdown-menu-end">

                    <h6 className="dropdown-header">Welcome {userName}!</h6>
                    <DropdownItem href={process.env.PUBLIC_URL + "/profile"}>
                        <i className="mdi mdi-account-circle text-muted fs-16 align-middle me-1"></i>
                        <span className="align-middle">Миний профайл</span>
                    </DropdownItem>
                    <DropdownItem href={process.env.PUBLIC_URL + "/profile"}>
                        <i className="mdi mdi-key-outline text-muted fs-16 align-middle me-1"></i>
                        <span className="align-middle">Нууц үг солих</span>
                    </DropdownItem>
                    <DropdownItem href={process.env.PUBLIC_URL + "/pages-faqs"}><i
                        className="mdi mdi-lifebuoy text-muted fs-16 align-middle me-1"></i> <span
                            className="align-middle">Тусламж</span></DropdownItem>
                    <div className="dropdown-divider"></div>  
                    <DropdownItem href={process.env.PUBLIC_URL + "/logout"} onClick={handleSignout}><i
                        className="mdi mdi-logout text-muted fs-16 align-middle me-1"></i> 
                        <span className="align-middle" data-key="t-logout">Гарах</span></DropdownItem>
                </DropdownMenu>
            </Dropdown>
        </React.Fragment>
    );
};

export default ProfileDropdown;